import React, { useEffect, useState } from "react";
import { Modal } from "@material-ui/core";
import styles from "./BulkReleaseVendingControllersModal.module.scss";
import Button from "../../button/Button";
import { toast } from "react-toastify";
import { CloseIcon } from "../../../assets";
import vendingControllersService from "../../../apis/services/admin/vendingControllersService";

const BulkReleaseVendingControllersModal = ({
  modalOpen,
  onClose,
  selectedControllers,
  onSuccess,
}) => {
  const [archiveNote, setArchiveNote] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!modalOpen) {
      setArchiveNote("");
    }
  }, [modalOpen]);

  const onSubmit = async () => {
    if (saving || selectedControllers.length === 0) {
      return;
    }
    setSaving(true);
    const failed = [];
    let released = 0;
    // Sekvencijalno: svaki release je nezavisna, atomična operacija na backendu;
    // greška na jednom ne zaustavlja ostale.
    for (const controller of selectedControllers) {
      try {
        await vendingControllersService.releaseVendingController({
          id: controller.id,
          archiveNote,
        });
        released += 1;
      } catch (err) {
        failed.push({
          macAddress: controller.macAddress || `#${controller.id}`,
          message:
            err?.response?.data?.message || err?.message || "Nepoznata greška",
        });
      }
    }
    setSaving(false);
    if (failed.length === 0) {
      toast.info(`Oslobođeno ${released} ESP uređaja`);
    } else {
      toast.warn(
        `Oslobođeno ${released}/${selectedControllers.length} — greška: ` +
          failed.map((f) => `${f.macAddress}: ${f.message}`).join("; ")
      );
    }
    onSuccess();
  };

  return (
    <Modal open={modalOpen} onClose={onClose}>
      <div className={styles.modalWrap}>
        <div className={styles.modalInner}>
          <div className={styles.header}>
            <div className={styles.closeIconWrap}>
              <img
                src={CloseIcon}
                alt="close"
                onClick={onClose}
                className={styles.closeIcon}
              />
            </div>
            <p className={styles.title}>
              Sačuvaj istoriju + oslobodi ESP ({selectedControllers.length})
            </p>
          </div>
          <div className={styles.content}>
            <p className={styles.confirmText}>
              Promet i računi ostaju dosadašnjim perionicama. ESP uređaji idu u
              pending listu i kasnije se dodeljuju standardno. Računi se ne
              brišu.
            </p>
            <div className={styles.formGroup}>
              <label className={styles.label}>
                Napomena (upisuje se na sve izabrane ESP-ove)
              </label>
              <textarea
                className={styles.noteTextarea}
                value={archiveNote}
                onChange={(event) => setArchiveNote(event.target.value)}
                placeholder="Napomena"
              />
            </div>
            <div className={styles.actions}>
              <Button
                name={saving ? "Oslobađanje..." : "Potvrdi"}
                onClick={onSubmit}
                disabled={saving || selectedControllers.length === 0}
                showLoader={saving}
              />
              <Button name="Otkaži" onClick={onClose} />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BulkReleaseVendingControllersModal;
